import { Helmet } from "react-helmet-async";

const SITE_NAME  = "The Health Plug";
const SITE_URL   = "https://thehealthplug.co.za";
const DEFAULT_OG = `${SITE_URL}/logo.jpeg`;

export default function SEO({ title, description, path = "", image, schema }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Youth Health PR & Impact Communications`;
  const canonical = `${SITE_URL}${path}`;
  const ogImage   = image || DEFAULT_OG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url"         content={canonical} />
      <meta property="og:image"       content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={ogImage} />

      {/* Page-specific structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
